import { StyledPay } from '../../../atoms/UserPanelTrainerPay/StyledPay';
import { StyledElement } from '../../../atoms/UserPanelTrainerPay/StyledElement';
import { StyledPayHour } from '../../../atoms/PayElement/StyledPayHour';
import { ScrollSyncPane } from 'react-scroll-sync';
import { StyledText } from '../../../atoms/Text/StyledText';
import { useMemo, useState, useRef } from 'react';
import { getDateString } from '../../../../logic/eventtime';
import { StyledSavePayElement } from '../../../atoms/PayElement/StyledSavePayElement';
import Decimal from 'decimal.js';

import CloseIcon from '../../../atoms/UserPanelStudens/CloseIcon';
import PencilIcon from '../../../atoms/UserPanelStudens/PencilIcon';
import AcceptIcon from '../../../atoms/UserPanelStudens/AcceptIcon';

import { StyledEditPay } from './PayHour/PayHour.styles';
import { StyledEditInputElement, StyledClosePayElement } from '../../../../styles/sharedStyles';
import { deleteOwnManagerHour, editOwnManagerHour } from '../../../../logic/requests/employees';
import PaymentsPopup from '../../Payments/PaymentsPopup';
import { getString } from '../../../../strings';

const ManagerHour = ({ hour, types, reloadHours }) => {
    const [isEdit, setIsEdit] = useState(false);
    const [confirmPopup, setConfirmPopup] = useState(false);
    const [isOpenShowDescriptionModal, setIsOpenShowDescriptionModal] = useState(false);

    const date = useMemo(() => getDateString(new Date(hour.date)), [hour]);
    const price = useMemo(() => new Decimal(hour?.price || 0), [hour]);

    const inputRefs = {
        date: useRef(),
        hours: useRef(),
        type: useRef(),
        description: useRef(),
    };

    const initialValues = useMemo(
        () => ({
            date: new Date(hour.date).toISOString().split('T')[0],
            hours: hour.hours,
            type: hour.type.id,
            description: hour.description,
        }),
        [hour]
    );

    const handleSubmit = (data, succFunc) => {
        if (!Object.keys(data).length) return succFunc();

        const onSuccess = (backend_data) =>
            succFunc?.({
                ...hour,
                ...data,
                ...(backend_data ?? {}),
            });

        editOwnManagerHour(hour.id, {
            ...hour,
            ...data,
        })
            .then((res) => {
                reloadHours();
                onSuccess(res);
            })
            .catch((err) => {
                console.error('handleSubmit', err);
            });
    };

    const handleDelete = (id, reloadFunc, confirmPopup, setConfirmPopup) => {
        deleteOwnManagerHour(id)
            .then(() => {
                reloadFunc();
                setConfirmPopup(confirmPopup);
            })
            .catch((err) => {
                console.error('handleDelete', err);
            });
    };

    return (
        <>
            {confirmPopup ? (
                <PaymentsPopup
                    title={getString('pay_hour_czy_na_pewno')}
                    onClose={() => setConfirmPopup(false)}
                    cancelTag={getString('addition_data_element_usun')}
                    onCancel={() =>
                        handleDelete(hour.id, reloadHours, confirmPopup, setConfirmPopup)
                    }
                />
            ) : null}
            {isOpenShowDescriptionModal ? (
                <PaymentsPopup
                    title={hour.description}
                    onClose={() => {
                        setIsOpenShowDescriptionModal(false);
                    }}
                />
            ) : null}
            <StyledPayHour key={hour.id}>
                <ScrollSyncPane>
                    <div>
                        {!isEdit ? (
                            <StyledPay>
                                <StyledElement>
                                    <StyledText
                                        hasdeclaredfontsize="16px"
                                        hasdeclaredfontweight="600"
                                        hasdeclaredtextalign="center"
                                        hasdeclaredlineheight="1.4em"
                                    >
                                        {hour.type.name}
                                    </StyledText>
                                </StyledElement>
                                <StyledElement>
                                    <StyledText
                                        hasdeclaredfontsize="16px"
                                        hasdeclaredfontweight="600"
                                        hasdeclaredtextalign="center"
                                        hasdeclaredlineheight="1.4em"
                                    >
                                        {date}
                                    </StyledText>
                                </StyledElement>
                                <StyledElement>
                                    <StyledText
                                        hasdeclaredfontsize="16px"
                                        hasdeclaredfontweight="600"
                                        hasdeclaredtextalign="center"
                                        hasdeclaredlineheight="1.4em"
                                    >
                                        {hour.hours}
                                    </StyledText>
                                </StyledElement>
                                <StyledElement>
                                    <StyledText
                                        hasdeclaredfontsize="16px"
                                        hasdeclaredfontweight="600"
                                        hasdeclaredtextalign="center"
                                        hasdeclaredlineheight="1.4em"
                                        onClick={() =>
                                            hour.description.length > 10 &&
                                            setIsOpenShowDescriptionModal(true)
                                        }
                                        hascursor={hour.description.length > 10 ? 'pointer' : ''}
                                    >
                                        {hour.description.length > 10
                                            ? hour.description.substring(0, 10) + '...'
                                            : hour.description}
                                    </StyledText>
                                </StyledElement>
                                <StyledElement>
                                    <StyledText
                                        hasdeclaredfontsize="16px"
                                        hasdeclaredfontweight="600"
                                        hasdeclaredtextalign="center"
                                        hasdeclaredlineheight="1.4em"
                                    >
                                        {price?.toString()} PLN
                                    </StyledText>
                                </StyledElement>
                            </StyledPay>
                        ) : (
                            <StyledEditPay>
                                <StyledEditInputElement $hasDeclaredWidth="20%">
                                    <select ref={inputRefs.type} defaultValue={initialValues.type}>
                                        {types.map((type) => (
                                            <option key={type.id} value={type.id}>
                                                {type.name}
                                            </option>
                                        ))}
                                    </select>
                                </StyledEditInputElement>
                                <StyledEditInputElement $hasDeclaredWidth="15%">
                                    <input
                                        type="date"
                                        ref={inputRefs.date}
                                        defaultValue={initialValues.date}
                                    />
                                </StyledEditInputElement>
                                <StyledEditInputElement $hasDeclaredWidth="10%">
                                    <input
                                        type="number"
                                        step="0.25"
                                        min="0.25"
                                        max="24"
                                        ref={inputRefs.hours}
                                        defaultValue={initialValues.hours}
                                    />
                                </StyledEditInputElement>
                                <StyledEditInputElement $hasDeclaredWidth="45%">
                                    <input
                                        type="text"
                                        ref={inputRefs.description}
                                        defaultValue={initialValues.description}
                                    />
                                </StyledEditInputElement>
                            </StyledEditPay>
                        )}
                    </div>
                </ScrollSyncPane>
                <StyledSavePayElement
                    isedit={isEdit}
                    onClick={
                        isEdit
                            ? () =>
                                  handleSubmit(
                                      Object.fromEntries(
                                          Object.entries(inputRefs)
                                              .map(([key, value]) => [key, value?.current?.value])
                                              .filter(
                                                  ([key, value]) => initialValues[key] !== value
                                              )
                                      ),
                                      setIsEdit(false)
                                  )
                            : () => setIsEdit(true)
                    }
                >
                    {!isEdit ? <PencilIcon /> : <AcceptIcon />}
                </StyledSavePayElement>
                <StyledClosePayElement
                    $isdisabled={!hour.canDelete}
                    disabled={!hour.canDelete}
                    onClick={isEdit ? () => setIsEdit(false) : () => setConfirmPopup(true)}
                >
                    <CloseIcon />
                </StyledClosePayElement>
            </StyledPayHour>
        </>
    );
};

export default ManagerHour;
